import {
    useMemo,
} from 'react'
import useContainerManagementRoutes from 'app/SkyNetRoutes/hooks/useContainerManagementRoutes'
import requestConfig from 'app/requests/ServiceCenter/ServiceCenter.requests'
import {
    useDataGridSource,
} from 'app/shared-components/SkyNetMasterDataGrid'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import SkyNetDataGrid from 'app/shared-components/SkyNetDataGrid'
import {
    generateSkyNetLink,
} from 'app/SkyNetRoutes'
import useLabel from 'app/hooks/useLabel'

import useStyles from '../ServiceCentersDemoScenarioEditor.styles'
import getColumns from './ContainersDamaged.columns'

const ContainersDamaged = ({
    serviceCenterId,
}: Readonly<{ serviceCenterId: number }>) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()

    const dataSource = useDataGridSource({
        request: requestConfig.containersDamaged({
            serviceCenterId,
        }),
        key: RequestKeys.filterContainersDamaged,
    })

    const {
        Containers: ContainersRoutes,
    } = useContainerManagementRoutes()

    const columns = useMemo(() => {
        return getColumns({
            getContainerLink: (serialNumber: string) => {
                return generateSkyNetLink({
                    domainPath: ContainersRoutes.Overview.path,
                    params: {
                        key: serialNumber,
                    },
                })
            },
            containerLinkClassName: classes.linkWrapper,
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [classes.linkWrapper])

    return (
        <SkyNetDataGrid
            persistentKey="demo-serviceCenterContainersDamaged-table"
            columns={columns}
            customDataSource={dataSource}
            toolbarProps={{
                title: l('CONTAINERS_DAMAGED'),
            }}
            classNames={{
                container: classes.tableContainer,
                tableWrapper: classes.tableWrapper,
            }}
        />
    )
}

export default ContainersDamaged
